// extracted by mini-css-extract-plugin
export default {"container":"cracked-board_container__javbG","hooks":"cracked-board_hooks__kOHcK","hook-anchors":"cracked-board_hook-anchors__mb+gm"};